'use strict';

module.exports = function last(fn) {
  if (typeof fn === 'function') {
    var collection = this.items.filter(fn);

    return collection[collection.length - 1];
  }

  return this.items[this.items.length - 1];
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/last.js
// module id = 1179
// module chunks = 2